import axios from 'axios'
import _ from 'lodash'

import triggerCustomGaEvent from '../utilities/analytics/triggerCustomGaEvent'
import apiConfiguration from '../utilities/api/apiConfiguration'
import getCookie from '../utilities/session/getCookie'
// import createReservation from './createReservation'
import fetchTransactionToken from './fetchTransactionToken'
import {getClientIdByHotelCode, getEndpointByHotelCode} from "../utilities/property/getClientIdByHotelCode";

export const CREATE_CART_BEGIN = 'CREATE_CART_BEGIN'
export const CREATE_CART_SUCCESS = 'CREATE_CART_SUCCESS'
export const CREATE_CART_ERROR = 'CREATE_CART_ERROR'

export const createCartBegin = ({
	type: CREATE_CART_BEGIN
})

export const createCartSuccess = confirmation => ({
	type: CREATE_CART_SUCCESS,
	payload: confirmation
})

export const createCartError = error => ({
	type: CREATE_CART_ERROR,
	payload: { error }
})

export default function createCart(renewedSessionId) {
	return (dispatch, getState) => {
		const urlData = getState().availabilityData.urlData
		const configData = getState().configData.configuration
		const activeRoom = getState().activeRoomData
		const activeEnhancements = getState().activeEnhancementData
		// const transactionTokens = getState().transactionTokenData.tokens

		// Initialize session variable
		let flowGuestData = null
		let hotelProvider = 0
		let sessionId = null

		// Set session for guest data passed VIA CMS
		if (localStorage && localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

		// Initialize cart payload
		let cartEntries = {
			createCartParameters: []
		}

		// Loop active rooms to construct payload values
		for (let roomKey in activeRoom) {

			// Initialize adults and children
			let adultsVal = 1,
					childrenVal = 0,
					childAgesVal,
					currentEnhancements = []

			// Set adults by session OR query with fallback
			if (
				flowGuestData &&
				flowGuestData[roomKey] &&
				flowGuestData[roomKey].adults >= 0
			){
				adultsVal = flowGuestData[roomKey].adults
			} else if (urlData.adults) {
				adultsVal = urlData.adults
			}

			// Set children by session OR query with fallback
			if (
				flowGuestData &&
				flowGuestData[roomKey] &&
				flowGuestData[roomKey].children >= 0
			) {
				childrenVal = flowGuestData[roomKey].children
			} else if (urlData.children) {
				childrenVal = urlData.children
			}

			if (urlData.childAges) {
				childAgesVal = urlData.childAges
			}

			if (activeEnhancements) {
				for (const enhancementKey in activeEnhancements) {
					const currentEnhancement = activeEnhancements[enhancementKey]

					if (
						currentEnhancement &&
						String(currentEnhancement.roomType) === String(activeRoom[roomKey][0][0].roomTypeCode) &&
						String(currentEnhancement.ratePlanCode) === String(activeRoom[roomKey][1][0].ratePlanCode) &&
						Number(currentEnhancement.roomGroup) === Number(roomKey)
					) {
						currentEnhancements.push({
							serviceInventoryCode: currentEnhancement.enhancementApiData.serviceInventoryCode,
							quantity: 1
						})
					}
				}
			}

			// Construct cart payload
			let cartEntry = {
				roomStays: {
					hotelCode: urlData.hotelCode,
					chainCode: configData.hotel.options.chainCode,
					dateStart: urlData.startDate,
					dateEnd: urlData.endDate,
					ratePlanCode: activeRoom[roomKey][1][0].ratePlanCode,
					promoCode: activeRoom[roomKey][1][0].ratePlanCode,
					adults: String(adultsVal),
					children: String(childrenVal),
					childAges: childAgesVal,
					roomTypes: {
						roomTypeCode: activeRoom[roomKey][0][0].roomTypeCode,
						numberOfUnits: '1'
					},
				},
				services: currentEnhancements
			}

			// Append cart payload to createCartParameters array
			cartEntries['createCartParameters'].push(cartEntry)
		}

    let currentClientId = getClientIdByHotelCode(urlData.hotelCode);
    let currentEndpointUrl = getEndpointByHotelCode(urlData.hotelCode);

		if (urlData.hotelProvider) {
			hotelProvider = urlData.hotelProvider
		}

		if (renewedSessionId ){
			sessionId = renewedSessionId
		} else if (
			getCookie('flowSessionId') &&
			getCookie('flowSessionId') !== ''
		) {
			sessionId = getCookie('flowSessionId')
		}

		// URL Params
		let urlParams = {
			hotelProvider: hotelProvider,
			sessionId: sessionId,
			clientId: currentClientId
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		// Begin create cart set loading true & error false
		dispatch(createCartBegin)

		// Base API path
		const apiBase = currentEndpointUrl + '/api/hotel/cart?'

		// Combine API URL & formatted urlParams
		const cartEndPoint = apiBase + fetchQuery.toString()

		// Submit POST to cart hotel endpoint
		axios.post(cartEndPoint, JSON.stringify(cartEntries),  apiConfiguration())
		.then((response) => {
			if(!_.isEmpty(response.data['hydra:member'][0])) {
				const currentCart = response.data['hydra:member'][0]

				// Initialize successful cart data model
				let activeCart = {}

				// Construct successful cart keyed by ID
				if (
					currentCart.id ||
					currentCart.id === 0
				) {
					activeCart[currentCart.id] = {
						id: currentCart.id,
						discount: currentCart.discount,
					}

					// Dispatch initial GA events
					triggerCustomGaEvent('analytics-createCart', activeCart)

					dispatch(createCartSuccess(activeCart))

					// // Fetch DPS2 Tokens for TARs Properties
					// if (
					// 	process.env.REACT_APP_COMPONENT_DSP2_PROVIDER === 'accor' &&
					// 	_.isEmpty(transactionTokens)
					// ) {
					// 	dispatch(fetchTransactionToken())
					// }

					if (activeCart && renewedSessionId) {
						dispatch(fetchTransactionToken(renewedSessionId))
					}
				} else {
					dispatch(createCartError('Error retrieving Cart ID'))
				}

			} else {
				dispatch(createCartError(response.data.errors[0].shortText))
			}
		})
		.catch(error => dispatch(createCartError(error)))
	}
}



// WEBPACK FOOTER //
// ./src/actions/createCart.js